import { UserInvoice } from "../types";
import { FC } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDollarSign, faReceipt } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { formatInvoiceCurrency, formatInvoiceMoment } from "../i18n";

interface Props {
    rates: UserInvoice["rates"];
}

const RatePaymentComponent: FC<React.PropsWithChildren<React.PropsWithChildren<Props>>> = ({ rates }) => {
    const { t, i18n } = useTranslation("invoice");
    return <div className="tw-min-w-[240px]">
        {rates.map((rate, index) => <div className="tw-text-xs tw-flex tw-gap-6 tw-items-center" key={index}>
            <span className="tw-col-span-2">{t("invoiceList.ratePayment.rateNumber", { number: index + 1 })}</span>
            <span className="tw-text-accents-8 tw-whitespace-nowrap"
            >{formatInvoiceMoment(rate.due_date ?? rate.date, i18n.resolvedLanguage, "L, LT")}</span>
            <span className="tw-col-span-2 tw-font-bold">{formatInvoiceCurrency(rate.total, i18n.resolvedLanguage)}</span>
            <div className="tw-flex tw-gap-2">
            <span>{rate.sepa_report_id ?
                <FontAwesomeIcon icon={faReceipt} className="tw-text-success" /> : null}</span>
                <span>{rate.payed_at ?
                    <FontAwesomeIcon icon={faDollarSign} className="tw-text-success" /> : null}</span>
            </div>
        </div>)}
    </div>;
};

export default RatePaymentComponent;
